<template>
	<v-container>
		<v-card class="mb-4" flat outlined>
			<v-card-title>
				{{title}}
			</v-card-title>
			<v-card-text>
				<v-data-iterator
					:items="sucursales"
					item-key="codigo"
				>
					<template v-slot:default="props">
						<v-row>
							<v-col
								v-for="item in props.items"
								:key="`col_${item.codigo}`"
								cols="12"
								sm="12"
								md="6"
								lg="item.total_records"
							>
								<v-card>
									<v-list dense>
										<v-list-item>
											<v-list-item-content>Código:</v-list-item-content>
											<v-list-item-content class="align-end">
												{{ item.codigo }}
											</v-list-item-content>
										</v-list-item>
										<v-list-item>
											<v-list-item-content>Sucursal:</v-list-item-content>
											<v-list-item-content class="align-end">
												{{ item.sucursal }}
											</v-list-item-content>
										</v-list-item>
										<v-list-item>
											<v-list-item-content>Direccion:</v-list-item-content>
											<v-tooltip top>
												<template v-slot:activator="{ on, attrs }">
													<v-list-item-content class="align-end limit-text" v-on="on">
														{{ item.direccion }}
													</v-list-item-content>
												</template>
												<span>{{item.direccion}}</span>
											</v-tooltip>
											
										</v-list-item>
										<v-list-item>
											<v-list-item-content>Comuna:</v-list-item-content>
											<v-list-item-content class="align-end">
												{{ item.comuna }}
											</v-list-item-content>
										</v-list-item>
										<v-list-item>
											<v-list-item-content>Ciudad:</v-list-item-content>
											<v-list-item-content class="align-end">
												{{ item.ciudad }}
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-card>
							</v-col>
						</v-row>
					</template>
				</v-data-iterator>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {

	name: 'Sucursal',
	props: {
		sucursales: {
			type: Array, // String, Number, Boolean, Function, Object, Array
			default: function(){
				return [
					{
						codigo: undefined,
						sucursal: undefined,
						direccion: undefined,
						comuna: undefined,
						ciudad: undefined
					}
				];
			}
		}
	},
	computed:{
		title(){
			let title = 'Sucursal';

			if(!!this.sucursales)
				title += this.sucursales.length > 1? 'es': ''

			return title;
		}
	},
	data () {
		return {

		}
	}
}
</script>

<style lang="css" scoped>
	.limit-text{
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>